<template>
  <v-stepper v-model="active" vertical class="pb-3">
    <v-stepper-step
      :color="steps.first.complete ? 'green' : 'primary'"
      :complete="steps.first.complete"
      :step="1"
    >
      Insira sua Senha
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-form v-model="steps.first.valid" @submit.prevent="steps.first.valid && verifyPassword()">
        <v-text-field
          label="Senha Atual"
          v-model="password"
          :type="hidePassword ? 'password' : 'text'"
          :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (hidePassword = !hidePassword)"
          :rules="[validationRules.required, validationRules.passwordMinLength]"
        />
      </v-form>
      <v-layout justify-center>
        <v-btn flat @click="toggleDialog(false)">Cancelar</v-btn>
        <v-btn
          class="white--text"
          color="blue"
          @click="verifyPassword"
          :disabled="!steps.first.valid"
        >
          Verificar
        </v-btn>
      </v-layout>
    </v-stepper-content>

    <v-stepper-step :complete="steps.second.complete" step="2">
      Código de Segurança
    </v-stepper-step>

    <v-stepper-content step="2">
      <v-layout align-start="">
        <span>
          Digite no campo abaixo o código que enviamos por sms para seu número
          <strong>{{ `(${user.phone.slice(0, 2)})****-*${user.phone.slice(7, 10)}` }}</strong>.
        </span>
        <img
          class="mr-3"
          src="/static/images/authentication/mobile-security-icon.svg"
          alt="Ícone de Segurança"
          width="64"
        />
      </v-layout>
      <v-layout align-center>
        <v-flex xs4 class="mr-3">
          <v-form v-model="steps.second.valid" @submit.prevent="steps.second.valid && verifySMSCode()">
            <v-text-field
              v-model="smsCode"
              label="Código"
              :rules="[validationRules.required, validationRules.smsCode]"
              mask="######"
              autofocus
            />
          </v-form>
        </v-flex>
        <v-flex xs8>
          <v-layout justify-end align-center>
            <span class="grey--text caption">Não recebeu?</span>
            <v-btn
              class="white--text"
              color="blue"
              flat
              small
              @click="verifySMSCode"
            >
              Reenviar
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-btn flat @click="resetValues(false)">Cancelar</v-btn>
        <v-btn
          class="white--text"
          color="blue"
          @click="verifySMSCode"
          :disabled="!steps.second.valid"
        >
          Confirmar
        </v-btn>
      </v-layout>
    </v-stepper-content>

  </v-stepper>
</template>

<script>
import validationRules from '@/mixins/validation-rules';
import formatString from 'format-string-by-pattern';
import passwordService from '@/services/PasswordService';

export default {
  name: 'stepper-security-verification',
  data() {
    return {
      active: 1,
      formatString,
      hidePassword: true,
      password: '',
      smsCode: '',
      steps: {
        first: { complete: false, valid: false },
        second: { complete: false, valid: false },
      },
      validationRules,
    };
  },
  methods: {
    toggleDialog(bool) {
      this.$emit('toggleDialog', bool);
    },
    verifyPassword() {
      this.steps.first.complete = true;
      this.active = 2;
      if (typeof passwordService.getSmsCode(this.password) === 'string') {
        this.smsCode = passwordService.getSmsCode(this.password);
      } else {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'error',
          message: 'Código Incorreto',
          button: { show: true, text: 'Fechar' },
          timeout: 6000,
        });
      }
    },
    verifySMSCode() {
      this.steps.second.complete = true;
      this.$emit('displayNewPasswordModal');
    },
    resetValues() {
      this.active = 1;
      this.password = '';
      this.phone = '';
      this.steps = {
        first: { complete: false, valid: false },
        second: { complete: false, valid: false },
      };
      this.hidePassword = true;
      this.toggleDialog(false);
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style>
  .theme--light .v-stepper--vertical .v-stepper__content:not(:last-child) {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/authentication/password/update/StepperSecurityVerification.vue